export default __webpack_public_path__ + "static/media/card-money.6728555d.webp";